import axios from "axios";
import { useEffect } from "react";

const ENV_BACKEND = process.env.REACT_APP_BACKEND_URL;
const sameHost = typeof window !== "undefined" && window.location.origin !== new URL(ENV_BACKEND).origin && !window.location.hostname.includes("localhost");
// On custom domains (eaocubo.com.br) the API is served on the same origin, so cookies stay first-party
export const BACKEND = sameHost ? window.location.origin : ENV_BACKEND;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const dt = (v) => (v ? new Date(v).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "-");
export const d = (v) => (v ? new Date(v).toLocaleDateString("pt-BR") : "-");
export const img = (u) => (!u ? "/demo/printer.jpg" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export function errMsg(e) {
  const det = e?.response?.data?.detail;
  if (!det) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof det === "string") return det;
  if (Array.isArray(det)) return det.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(det);
}

export const effPrice = (p) => Number(p?.promo_price || p?.price || 0);
export const pixPrice = (p, pct) => (p?.pix_price ? Number(p.pix_price) : effPrice(p) * (1 - (pct || 0) / 100));

export function track(event, data = {}) {
  try {
    if (window.fbq) window.fbq("track", event, data);
    if (window.gtag) window.gtag("event", { ViewContent: "view_item", Search: "search", AddToCart: "add_to_cart", BeginCheckout: "begin_checkout", Purchase: "purchase" }[event] || event, data);
    if (window.dataLayer) window.dataLayer.push({ event, ...data });
  } catch (e) {
    /* tracking must never break the store */
  }
}

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

export function useSeo({ title, description, image, jsonLd }) {
  useEffect(() => {
    const t = title ? `${title} | E³ Impressão 3D` : "E³ Impressão 3D | Produtos 3D personalizados";
    document.title = t;
    setMeta("name", "description", description || "Produtos criativos, personalizados e produzidos em impressão 3D.");
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:image", image || "/brand/logo-sm.png");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `https://eaocubo.com.br${window.location.pathname}`;
    let s = document.getElementById("jsonld");
    if (s) s.remove();
    if (jsonLd) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "jsonld";
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, image, jsonLd]);
}

export const ORDER_STATUS = {
  recebido: "Pedido recebido", aguardando_pagamento: "Aguardando pagamento", pagamento_aprovado: "Pagamento aprovado",
  em_producao: "Em produção", producao_concluida: "Produção concluída", em_preparacao: "Em preparação",
  enviado: "Enviado", entregue: "Entregue", cancelado: "Cancelado", reembolsado: "Reembolsado",
};
export const PAY_STATUS = {
  pendente: "Pendente", em_processamento: "Em processamento", aprovado: "Aprovado", recusado: "Recusado",
  cancelado: "Cancelado", reembolsado: "Reembolsado", contestado: "Contestado",
};
